export default {
	author: { type: 'string' },
	version: { type: 'string', path: 'version.currentVersion' },
	createdAt: { type: 'datetime' },
	fileName: { type: 'string' }
}
